module.exports = __webpack_public_path__ + "img/bootstrap.ab904daa.jpg";